module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-st.7de9bee5.png";